import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import CircleList from '../../CircleList';
import { TEAM_PROFILE } from '../../../constants/strings';
import { enhance } from './enhance';

const TeamProfile = ({ formatMessage, profile }) => {
  return (
    <div className="pl2">
      <CircleList
        list={get(profile, 'actingAsTeam.users', [])}
        title={formatMessage({ id: 'teams.teamMember' })}
        type={TEAM_PROFILE}
      />
    </div>
  );
};

TeamProfile.propTypes = {
  profile: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default enhance(TeamProfile);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/TeamProfile/index.jsx